import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { ANNOTATION_USER_TITLE } from '@appfolio/backstage-plugin-catalog-common';

const FACET = `metadata.annotations.${ANNOTATION_USER_TITLE}`;

class EntityUserTitleFilter implements EntityFilter {
  public constructor(readonly values: string[]) {}

  public getCatalogFilters(): Record<string, string | string[]> {
    return { [FACET]: this.values };
  }

  public toQueryValue(): string[] {
    return this.values;
  }
}

export const EntityUserTitlePicker = () => (
  <EntityAutocompletePicker<
    DefaultEntityFilters & {
      userTitle: EntityUserTitleFilter;
    }
  >
    label="Title"
    name="userTitle"
    path={FACET}
    Filter={EntityUserTitleFilter}
  />
);
